import { createTheme } from '@mui/material/styles';

// LDM brand colors based on the provided images
const ldmTheme = createTheme({
  palette: {
    primary: {
      main: '#2D3A45', // Dark blue/slate gray from the footer
      light: '#3D4A55',
      dark: '#1D2A35',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#FF5722', // Orange accent color from the logo
      light: '#FF7A50',
      dark: '#E04000',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#F5F5F5', // Light gray for the main background
      paper: '#FFFFFF',
    },
    text: {
      primary: '#2D3A45',
      secondary: '#5A6A75',
    },
  },
  typography: {
    fontFamily: [
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h4: {
      fontWeight: 500,
    },
    h5: {
      fontWeight: 500,
    },
    h6: {
      fontWeight: 500,
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#2D3A45', // Dark blue/slate gray
          borderRadius: 0, // No rounded corners
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#2D3A45', // Dark blue/slate gray
          color: '#FFFFFF',
          borderRadius: 0, // No rounded corners
          borderRight: 'none', // No border
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: '#FFFFFF', // White icons in the sidebar
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          // Only apply white text to sidebar items, not all list items
          '.MuiDrawer-paper &': {
            color: '#FFFFFF', // White text in the sidebar
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // Don't uppercase button text
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          '&.MuiAppBar-root, &.MuiDrawer-paper': {
            borderRadius: 0,
          },
        },
      },
    },
  },
});

export default ldmTheme;
